const API_ROOT = `${process.env.REACT_APP_API_URL}/api/v1/`;

const parkingRequest = (method, endpoint, body) => {
  const serializedBody = method !== 'GET' ? { body: JSON.stringify(body) } : null;

  // let creds = null;

  // if (localStorage.state) {
  //   const localState = JSON.parse(localStorage.state);
  //   creds = {
  //     "X-ParkingAttendant-Email": localState.parkingAuth.email,
  //     "X-ParkingAttendant-Token": localState.parkingAuth.token
  //   };
  // }

  const config = {
    method,
    headers: {
      // ...creds,
      'Content-Type': 'application/json',
    },
    ...serializedBody,
  };

  return fetch(`${API_ROOT}${endpoint}`, config)
    .then(response => handleErrors(response))
    .catch(err => {
      throw err;
    });
};

const handleErrors = response =>
  response.json().then(responseData => {
    // If response has a status outside 200-299 then it will be caught here
    if (!response.ok) {
      console.log('Request error');
      throw responseData;
    }
    return responseData;
  });

// Pass in auth token once implemented
export const getData = endpoint => parkingRequest('GET', endpoint);
export const deleteData = endpoint => parkingRequest('DELETE', endpoint);
export const postData = (endpoint, body) => parkingRequest('POST', endpoint, body);
export const putData = (endpoint, body) => parkingRequest('PUT', endpoint, body);



// WEBPACK FOOTER //
// ./src/utils/parkingRequest.js